import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';
import Dashboard from './components/Dashboard';


function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Navigation Header */}
        <nav className="navbar">
          <Link to="/dashboard" className="nav-brand">
            <span>M</span> Manager Dashboard
          </Link>
          <div className="nav-links">
          </div>
        </nav>

        {/* Main Content Area */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/home" element={<Navigate to="/dashboard" replace />} />
            <Route path="/index" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;

